import {Injectable} from '@angular/core';
import {DeviceService} from './device.service';

@Injectable()
export class BrowserDeviceService extends DeviceService {
  isMobileDevice(): boolean {
    return (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent));
  }

  isSafariBrowser(): boolean {
    return navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.indexOf('Chrome') < 0;
  }
}
